import styled from 'styled-components'

export default styled.div`
  font-size: 16px;
  font-weight: 500;
  line-height: 18px;
  margin-bottom: 10px;
`
